import React from 'react'
import { StylesOf, useBooleanToggle, getNestedStylesByKey, PropsOf } from '@codeleap/common'
import { HeaderComposition } from '../../app/stylesheets/Header'
import { NavContent } from './Content'
import { ActionIcon, Drawer } from '@/components'

export type DrawerMenuProps = Partial<PropsOf<typeof Drawer>> & {
  isMobile?: boolean
  variantStyles?: StylesOf<HeaderComposition>
}

export const DrawerMenu = (props: DrawerMenuProps) => {
  const { isMobile, variantStyles, ...rest } = props

  const [drawerOpen, toggleDrawer] = useBooleanToggle(false)

  const menuIconStyles = getNestedStylesByKey('menuIcon', variantStyles)
  const drawerStyles = getNestedStylesByKey('drawer', variantStyles)

  return <>
    <Drawer
      styles={drawerStyles}
      debugName='header:drawer'
      open={drawerOpen}
      size='75vw'
      position='right'
      toggle={toggleDrawer}
      showCloseButton
      {...rest}
    >
      <NavContent isMobile={isMobile} variantStyles={variantStyles} />
    </Drawer>

    <ActionIcon
      debugName='header:menuButton'
      icon='menu'
      styles={menuIconStyles}
      onPress={toggleDrawer}
    />
  </>
}
